export enum ModalActions {
  OpenModal = 'open modal',
  OpenModalRedux = 'open modal redux',
  CloseModal = 'close modal',
  RequestOpenModal = 'request open modal',
  CloseTooltip = 'close modal tooltip',
  CloseTooltips = 'close modal tooltips',
  OpenTooltip = 'open modal tooltip',
  ToggleHideModal = 'toggle hide modal',
}
